import gql from 'graphql-tag';

export default gql`
  mutation ($input: uploadPremiumHEMProfileImageInput!) {
    uploadPremiumHEMProfileImage(input: $input) {
      scanAndUploadSuccess
      imgPath
      url
    }
  }
`;
